// ./src/contexts/HighlightsContext/HighlightsContext.tsx
//
// Thin context wrapper around the useHighlights hook. All derived data lives in
// the hook itself. See PersonsContext for the pattern.

import React, { createContext, useContext } from "react";

import { useHighlights, UseHighlightsOptions, UseHighlightsReturn } from "@/hooks/useHighlights";

const HighlightsContext = createContext<UseHighlightsReturn | null>(null);

export interface HighlightsProviderProps extends UseHighlightsOptions {
  children: React.ReactNode;
}

export const HighlightsProvider: React.FC<HighlightsProviderProps> = ({ children, ...options }) => {
  const value = useHighlights(options);

  return <HighlightsContext.Provider value={value}>{children}</HighlightsContext.Provider>;
};

export const useHighlightsContext = (): UseHighlightsReturn => {
  const context = useContext(HighlightsContext);

  if (!context) {
    throw new Error(
      "useHighlightsContext must be used within a <HighlightsProvider>. " +
        "Wrap your component tree with <HighlightsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalHighlightsContext = (): UseHighlightsReturn | null => {
  return useContext(HighlightsContext);
};
